"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reduxActions = require("redux-actions");

var _httpActions = require("../actions/http-actions");

var _util = require("./util");

var _applicationActions = require("../actions/application-actions");

var _handleActions;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var initialState = {
  documentsByApplicationUuid: {// '286fcce0-6811-4575-946b-c5060e9f81fc': {
    //   applicationUuid: '286fcce0-6811-4575-946b-c5060e9f81fc',
    //   generatedDocuments: [
    //     {
    //       uuid: 'b428c5ff-8cad-4963-983a-41b946ace0ff',
    //       applicationUuid: '286fcce0-6811-4575-946b-c5060e9f81fc',
    //       documentUuid: ''
    //     }
    //   ]
    // }
  },
  loading: false
};
exports.initialState = initialState;

function merge(state, action) {
  var applicationUuid = action.meta.applicationUuid;
  var generatedDocuments = state.documentsByApplicationUuid[applicationUuid] || {};
  return _objectSpread(_objectSpread({}, state), {}, {
    documentsByApplicationUuid: _objectSpread(_objectSpread({}, state.documentsByApplicationUuid), {}, (0, _defineProperty2.default)({}, applicationUuid, _objectSpread(_objectSpread({}, generatedDocuments), {}, {
      applicationUuid: applicationUuid,
      generatedDocuments: (0, _util.mergeList)(generatedDocuments.documents, action.payload)
    }))),
    loading: false
  });
}

var reducer = (0, _reduxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, "".concat(_applicationActions.GET_DOCUMENTS_GENERATED, "_").concat(_httpActions.REQUEST), function _() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  return _objectSpread(_objectSpread({}, state), {}, {
    loading: true
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_applicationActions.GET_DOCUMENTS_GENERATED, "_").concat(_httpActions.SUCCESS), function _(state, action) {
  return merge(state, action);
}), _handleActions), initialState);
var _default = reducer;
exports.default = _default;